import { secretKey } from "./data";

export const logCopy = (leadId, user, field, value) => {
  if (!leadId || !field || !value) return;

  fetch("https://apiftpsplit.ftpeople.pl/addLogCopy", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: secretKey,
    },
    body: JSON.stringify({
      leadId,
      userId: user ? user.id : null,
      userName: user ? user.name : null,
      field,
      value,
    }),
  }).catch(() => {});
};

// A single document-level "copy" listener is shared across every component
// that mounts this logger (LeadDetail is rendered inside Database/LeadQue at
// the same time), so copies aren't logged more than once.
let listenerCount = 0;
let currentUser = null;

const handleCopy = () => {
  const selection = window.getSelection();
  const text = selection ? selection.toString() : "";
  if (!text) return;

  const anchor = selection.anchorNode;
  const el = anchor && anchor.nodeType === 3 ? anchor.parentElement : anchor;
  const target = el && el.closest ? el.closest("[data-log-field]") : null;
  if (!target) return;

  logCopy(
    target.getAttribute("data-log-lead-id"),
    currentUser,
    target.getAttribute("data-log-field"),
    text
  );
};

export const attachCopyLogger = (user) => {
  currentUser = user;
  if (listenerCount === 0) {
    document.addEventListener("copy", handleCopy);
  }
  listenerCount += 1;

  return () => {
    listenerCount -= 1;
    if (listenerCount === 0) {
      document.removeEventListener("copy", handleCopy);
    }
  };
};
